import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmService, IConfirmSetup } from 'src/app/core/confirm.service';
import { STANDALONE_COMPONENT_IMPORTS } from '../standalone-component-imports';

@Component({
    standalone: true,
    imports: STANDALONE_COMPONENT_IMPORTS,
    selector: 'pd-confirmation-dialogue',
    templateUrl: './confirmation-dialogue.component.html',
    styleUrls: [],
})
export class ConfirmationDialogueComponent implements OnInit, OnDestroy {
    public active: boolean;
    public setup: IConfirmSetup;

    private readonly subscriptions: Subscription[] = [];

    constructor(private readonly confirmService: ConfirmService) {}

    ngOnInit(): void {
        this.subscriptions.push(
            this.confirmService.setupStream.subscribe(setup => {
                this.setup = setup;
                this.active = true;
            })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    public cancel(): void {
        this.confirmService.decision(false);
        this.active = false;
    }

    public confirm(): void {
        this.confirmService.decision(true);
        this.active = false;
    }
}
